module.exports = __webpack_public_path__ + "static/email-illustration-a1ad24916d979e088c5e8c80b073f92b.svg";